import React from 'react';

export default function ManageUser() {
  return <div>Manage All User list form</div>;
}
